import React, { Fragment } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts } from '@/utils/preset'
import { tablet, mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import SectionHead from '@/components/app/SectionHead'
import Card from './Card'

const Template = props => {
  const { ...others } = props
  return (
    <StaticQuery
      query={query}
      render={data => (
        <Root {...others}>
          <Container>
            <Head
              sub="OPTIONS"
              main={(
                <Fragment>オプション</Fragment>
              )}
              body={(
                <Fragment>自社で運営しているECサイトやメディアで培った知見をベースに、WEBマーケティング・広告運用をはじめとした関連業務は全て対応できます。弊社には月間最大PV数50万のブログを運営するプロのブロガー、プロの現場で活躍する映像・音楽クリエイターも在籍しているため、多角的なプロモーション展開が可能です。</Fragment>
              )}
            />
            <List>
              <List_Inner>
                <List_Item>
                  <Card
                    icon={data.option1.childImageSharp.fluid}
                    title="SNS運用"
                    desc={(
                      <Fragment>成果の出やすいコンテンツの傾向の特定し、効果的・効率的なSNS運用を提案します。企画、分析、運用提案、コンテンツ提供、成果レポートなど対応。</Fragment>
                    )}
                  />
                </List_Item>
                <List_Item>
                  <Card
                    icon={data.option2.childImageSharp.fluid}
                    title="広告運用"
                    desc={(
                      <Fragment>Google、Facebook、Instagramなど、WEB広告設定と成果分析・レポート作成を行います。広告素材（バナー、テキスト）も弊社で制作可能です。</Fragment>
                    )}
                  />
                </List_Item>
                <List_Item>
                  <Card
                    icon={data.option3.childImageSharp.fluid}
                    title={(
                      <Fragment>メディアプランニング<br />記事制作</Fragment>
                    )}
                    desc={(
                      <Fragment>Google検索から集客数を増やすための記事コンテンツを企画、作成します。依頼主様のヒアリングをもとに、ビジョンに沿った記事を執筆します。</Fragment>
                    )}
                  />
                </List_Item>
                <List_Item>
                  <Card
                    icon={data.option4.childImageSharp.fluid}
                    title="写真撮影"
                    desc={(
                      <Fragment>物撮りはもちろん、ポートレート、風景など、商品単体や利用シーンの写真撮影を行います。利用する媒体や用途に合わせた画像の補正もお受けします。</Fragment>
                    )}
                  />
                </List_Item>
                <List_Item>
                  <Card
                    icon={data.option5.childImageSharp.fluid}
                    title="映像制作"
                    desc={(
                      <Fragment>撮影から編集まで一貫して対応。実写に限らず、アニメーションや3DCG、オリジナルBGMの作成も可能です。企画段階からぜひご相談ください。</Fragment>
                    )}
                  />
                </List_Item>
                <List_Item>
                  <Card
                    icon={data.option6.childImageSharp.fluid}
                    title={(
                      <Fragment>WEBマーケティング<br />戦略立案・実行</Fragment>
                    )}
                    desc={(
                      <Fragment>戦略設計、KPI設定、マーケティングプラン作成、行動計画作成など、WEBマーケティングに関する業務は一括してお任せください。</Fragment>
                    )}
                  />
                </List_Item>
                <List_Item>
                  <Card
                    icon={data.option7.childImageSharp.fluid}
                    title={(
                      <Fragment>パッケージデザイン</Fragment>
                    )}
                    desc={(
                      <Fragment>ECサイトのリニューアルや商品のリブランディング等にあわせて、商品のパッケージデザインやブランドロゴ、オリジナルグラフィックの作成が可能です。</Fragment>
                    )}
                  />
                </List_Item>
                <List_Item>
                  <Card
                    icon={data.option8.childImageSharp.fluid}
                    title={(
                      <Fragment>商品企画・開発サポート</Fragment>
                    )}
                    desc={(
                      <Fragment>市場調査・競合調査を行い、総合的に現況を分析し、商品開発をサポートすることが可能です。プロダクトデザインや製作についてもご相談ください。</Fragment>
                    )}
                  />
                </List_Item>
                <List_Item>
                  <Card
                    icon={data.option9.childImageSharp.fluid}
                    title={(
                      <Fragment>ITを活用した業務改善</Fragment>
                    )}
                    desc={(
                      <Fragment>出荷業務等、商品の販売に付随する単純なオペレーション作業を標準化・自動化することで、業務効率を改善することができます。</Fragment>
                    )}
                  />
                </List_Item>
              </List_Inner>
            </List>
          </Container>
        </Root>
      )}
    />
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  background-color: ${props => props.theme.gray.a};
  padding: ${rem(56)} ${rem(layouts.defs.pad.base)};
  @media ${mq.and(tablet)} {
    padding: ${rem(60)} ${rem(layouts.defs.pad.tablet)};
  }
  @media ${mq.and(mobile)} {
    padding: ${rem(56)} ${rem(layouts.defs.pad.mobile)} ${rem(56)};
  }
`

const Head = styled(SectionHead)``

const Container = styled.div`
  margin: 0 auto;
`

const List = styled.div`
  margin-top: ${rem(40)};

  @media ${mq.and(mobile)} {
    overflow-x: scroll;
    padding-bottom: ${rem(16)};
    margin-left: -${rem(layouts.defs.pad.mobile)};
    margin-right: -${rem(layouts.defs.pad.mobile)};
  }
`

const List_Inner = styled.ol`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${rem(-24)};
  margin-left: ${rem(-12)};
  margin-right: ${rem(-12)};

  @media ${mq.and(mobile)} {
    flex-wrap: nowrap;
    margin-left: 0;
    margin-right: 0;
    padding-left: ${rem(layouts.defs.pad.mobile)};
    padding-right: ${rem(layouts.defs.pad.mobile)};
  }
`

const List_Item = styled.li`
  width: 33.333333%;
  padding: 0 ${rem(12)};
  margin-top: ${rem(24)};

  @media ${mq.and(mobile)} {
    width: 80%;
    flex-shrink: 0;
    padding: 0;
    padding-right: ${rem(24)};
  }
`

export const query = graphql`
  query OptionsSectionQuery {
    option1: file(relativePath: { eq: "option-1.png" }) {
      childImageSharp {
        fluid(maxWidth: 100, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    option2: file(relativePath: { eq: "option-2.png" }) {
      childImageSharp {
        fluid(maxWidth: 100, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    option3: file(relativePath: { eq: "option-3.png" }) {
      childImageSharp {
        fluid(maxWidth: 100, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    option4: file(relativePath: { eq: "option-4.png" }) {
      childImageSharp {
        fluid(maxWidth: 100, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    option5: file(relativePath: { eq: "option-5.png" }) {
      childImageSharp {
        fluid(maxWidth: 100, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    option6: file(relativePath: { eq: "option-6.png" }) {
      childImageSharp {
        fluid(maxWidth: 100, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    option7: file(relativePath: { eq: "option-7.png" }) {
      childImageSharp {
        fluid(maxWidth: 100, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    option8: file(relativePath: { eq: "option-8.png" }) {
      childImageSharp {
        fluid(maxWidth: 100, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    option9: file(relativePath: { eq: "option-9.png" }) {
      childImageSharp {
        fluid(maxWidth: 100, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`
